import { choose } from '../../utils/platform';
import FamilyMemberFormDesktop from './FamilyMemberForm.desktop';
import FamilyMemberFormMobile from './FamilyMemberForm.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
// Props: { head, rows, onClose, onSave, isMarriage, sideOptions } — logic in useFamilyMemberForm.
export default choose(FamilyMemberFormDesktop, FamilyMemberFormMobile);
